import { ComponentType } from 'react';
import { SelectProps } from '@mui/material/Select/Select';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { map, get, isString } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useQuestionFields } from '../../../hooks';

interface QuestionsFieldsSelectProps extends SelectProps {
  className?: string;
  error?: boolean;
  helperText?: string;
  InputProps?: Record<string, any>;
  prompt?: boolean | string;
}

export const QuestionsFieldsSelect: ComponentType<QuestionsFieldsSelectProps> = ({
  label,
  error = false,
  helperText,
  InputProps,
  prompt = false,
  ...props
}) => {
  const { t } = useTranslation();
  const { fields } = useQuestionFields();

  const value = String(get(props, 'value', ''));
  const options = map(fields.hits, (item, idx) => (
    <MenuItem value={get(item, 'id', '')} key={idx}>
      {get(item, 'name', 'None')}
    </MenuItem>
  ));

  if (prompt) {
    options.unshift(
      <MenuItem value="" key="prompt">
        {isString(prompt) ? prompt : t('action.select', 'Выбрать')}
      </MenuItem>
    );
  }

  return (
    <FormControl error={error} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select {...{ ...props, label, value }}>{options}</Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
